﻿import {translation} from "@2d-front-monorepo/core";
import {LinkButton, Markdown} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {Navigate} from "react-router";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {appConfig} from "../config/appConfig";
import {getDefaultLandingPage} from "../functions";
import {useUser} from "../hooks/useUser";

import {PublicRoutes} from "../routes";

export default function SherbrookeWelcomePage(): JSX.Element {
	const user = useUser();

	if (user.authStatus == "logged-in") {
		return (<Navigate to={getDefaultLandingPage()}></Navigate>)
	}

	return (
		<section className="welcome full-layout full-layout--centered">
			<h1>{translation(PermitTranslations.welcome_page__title)}</h1>
			<Markdown markdown={translation(PermitTranslations.welcome_page__body)}/>

			<div className="layout vertical gap">
				<LinkButton to={PublicRoutes.signIn} kind="primary">{translation(PermitTranslations.sign_in)}</LinkButton>
				<small style={{textAlign: "center"}}>{translation(PermitTranslations.welcome_page__or)}</small>
				<LinkButton to={PublicRoutes.signUp}>{translation(PermitTranslations.sign_up)}</LinkButton>
			</div>

			<div className="layout vertical">
				<h3 style={{marginBlockEnd: 0}}>{translation(PermitTranslations.sherbrooke__home__1)}</h3>
				<p>{translation(PermitTranslations.sherbrooke__home__2)}</p>
				<LinkButton to={appConfig.homeLinks!.link1} kind="primary">{translation(PermitTranslations.sherbrooke__home__button__1)}</LinkButton>
				<h3>{translation(PermitTranslations.sherbrooke__home__3)}</h3>
				<LinkButton to={appConfig.homeLinks!.link2!}>{translation(PermitTranslations.sherbrooke__home__button__2)}</LinkButton>
			</div>

			<Markdown markdown={translation(PermitTranslations.website__terms_and_conditions)} className="terms-and-conditions"/>
		</section>
	);
}
